// extracted by mini-css-extract-plugin
export default {"icon":"searchInput_icon__nZO+a","input":"searchInput_input__p-sx6","closeIcon":"searchInput_closeIcon__Nuf+2","loader":"searchInput_loader__Imzih"};